import http from '../common/http'

export const GetNavigation = (params) => (
    http.get('/Trouble/GetNavigation', params)
)

// export const GetBrand = () => (
//     http.get('/Trouble/GetNavigation', { navCode: 'CODE 002', catSysno: 0 })
// )

// export const GetMobile = brandId => (
//     http.get('/Trouble/GetNavigation', { navCode: 'CODE 002', catSysno: brandId })
// )

// export const GetProducts =  (params)  => (
//     http.get('/Trouble/GetProducts', params)
// )

// export const GetSku = property => (
//     http.post('/Trouble/GetSkuBySpuProperies', {...property})
// )

// export const GetProduct = sku => (
//     http.get('/Trouble/GetWareInfo', { skuCode: sku })
// )


// WEBPACK FOOTER //
// ./src/api/troubleApi.js